<div class="sc-payment-method-confirm" [class.sc-payment-method-confirm--loading]="loading">
    <div class="sc-payment-method-confirm__header">
        <div class="sc-payment-method-confirm__method-title">
            <sc-icon [icon]="paymentMethodIcon"></sc-icon> {{ paymentMethodTitle }}
        </div>
        <div class="sc-payment-method-confirm__link">
            <sc-button type="link" (onClick)="changeMethodClicked.emit()" [disabled]="disabled || loading" id="confirm-payment-method-cambiar">Cambiar</sc-button>
        </div>
    </div>
    <div class="sc-payment-method-confirm__content" *ngIf="!loading">
        <div class="sc-payment-method-confirm__fee">
            {{ paymentFee }} Cuota<ng-container *ngIf="paymentFee > 1">s</ng-container> de
        </div>
        <div class="sc-payment-method-confirm__cost">
            {{ (finalAmount / paymentFee) | scCurrency }}
        </div>
        <div *ngIf="paymentFee > 1" class="sc-payment-method-confirm__final-cost">
            Precio final: {{ finalAmount | scCurrency }}
        </div>
    </div>
    <div class="sc-payment-method-confirm__loading" *ngIf="loading">
        <sc-icon icon="loading" size="2"></sc-icon>
    </div>
</div>
